// src/Dashboard/pages/user/Messaging/components/MessagingHeader.jsx

import React from "react";
import {
  FaInbox,
  FaPaperPlane,
  FaUsers,
  FaComments,
  FaPlus,
} from "react-icons/fa";
import { LuMessageSquarePlus } from "react-icons/lu";

export default function MessagingHeader({
  isManager,
  unreadCount,
  onComposePrivate,
  onComposeGroup,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaComments />
              Messagerie & canaux
            </div>

            <h1 className="mt-4 text-2xl font-bold sm:text-3xl">
              Centre de communication
            </h1>

            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/90">
              Retrouvez vos messages privés, vos messages envoyés et les canaux
              de discussion accessibles selon votre rôle et vos groupes.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaInbox />
                Reçus {unreadCount > 0 ? `(${unreadCount} non lu)` : ""}
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaPaperPlane />
                Envoyés
              </span>

              <span className="inline-flex items-center gap-2 rounded-2xl bg-white/15 px-3 py-2 text-xs font-bold ring-1 ring-white/20">
                <FaUsers />
                Canaux de groupes
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row">
            <button
              type="button"
              onClick={onComposePrivate}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-white/90"
            >
              <LuMessageSquarePlus />
              Nouveau message
            </button>

            {isManager && (
              <button
                type="button"
                onClick={onComposeGroup}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-slate-800"
              >
                <FaPlus />
                Message groupé
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}